import React, { useCallback, useContext, useMemo, useRef, useState } from 'react'

import { AIAgentResultCitationTooltip } from '../../../../../../../../views/AIAgent/AIAgentResultCitations/AIAgentResultCitations'
import { useOutsideClick } from '../../../../../../../../common/useOutsideClick'

import { CitationNodeContext } from './CitationNodeContext'

import './CitationNodeComponent.scss'

interface CitationNodeComponentProps {
  citationId: string
}

export const CitationNodeComponent: React.FC<CitationNodeComponentProps> = ({ citationId }) => {
  const { citations } = useContext(CitationNodeContext)

  const index = citations.findIndex((e) => e.id === citationId)
  const citation = index > -1 ? citations[index] : null

  const [show, setShow] = useState<boolean>(false)
  const ref = useRef<HTMLSpanElement>(null)
  const tooltipRef = useRef<HTMLDivElement>(null)

  const hideTooltip = useCallback(() => setShow(false), [])
  const citationsToDisplay = useMemo(() => {
    return citation ? [citation] : []
  }, [citation])

  useOutsideClick(tooltipRef, hideTooltip)

  const handleOnClick = () => {
    if (!citation) {
      return
    }
    setShow((v) => !v)
  }

  if (!citation) {
    return null
  }

  return (
    <>
      <sup ref={ref} className='superscript-node d-inline-flex align-items-center justify-content-center ms-1 ignore-in-pdf' onClick={handleOnClick}>
        {index + 1}
      </sup>
      <AIAgentResultCitationTooltip citations={citationsToDisplay} index={index} show={show} target={ref.current} tooltipRef={tooltipRef} />
    </>
  )
}
